export interface MissingItem {
  id: string;
  customerId: string;
  organizationId: string;
  description: string;
  category: 'invoice' | 'receipt' | 'contract' | 'document' | 'other';
  dueDate?: Date;
  priority: 'low' | 'medium' | 'high' | 'urgent';
  status: 'pending' | 'acknowledged' | 'uploaded' | 'approved' | 'rejected';
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  acknowledgedAt?: Date;
  acknowledgedBy?: string;
  uploadedAt?: Date;
  uploadedFiles?: string[];
  approvedAt?: Date;
  approvedBy?: string;
  rejectedAt?: Date;
  rejectedBy?: string;
  rejectionReason?: string;
  notes?: string;
  customerMessage?: string; // Egyedi üzenet az ügyfélnek a Customer Portalon
}

export interface MissingItemNotificationSettings {
  organizationId: string;
  enabled: boolean;
  frequency: 'daily' | 'weekly' | 'monthly';
  dayOfWeek?: number; // 0-6 (Sunday-Saturday)
  dayOfMonth?: number; // 1-31
  time: string; // HH:mm format
  emailTemplate?: string;
  lastSentAt?: Date;
}

export const MISSING_ITEM_CATEGORIES = {
  invoice: 'Számla',
  receipt: 'Bizonylat',
  contract: 'Szerződés',
  document: 'Dokumentum',
  other: 'Egyéb'
} as const;

export const MISSING_ITEM_PRIORITIES = {
  low: 'Alacsony',
  medium: 'Közepes',
  high: 'Magas',
  urgent: 'Sürgős'
} as const;

export const MISSING_ITEM_STATUSES = {
  pending: 'Függőben',
  acknowledged: 'Nyugtázva',
  uploaded: 'Feltöltve',
  approved: 'Jóváhagyva',
  rejected: 'Elutasítva'
} as const;
